// extracted by mini-css-extract-plugin
module.exports = {"theArt":"TheArt_theArt__1YGKo"};